var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"x":_vm.x,"y":_vm.y,"viewBox":"0 0 580 460"}},[_vm._t("default",function(){return [_c('g',{domProps:{"innerHTML":_vm._s(_vm.path)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }